import { FC, useMemo } from 'react';
import styled, { css } from 'styled-components';
import { LabelBigRedStar } from '../designerEditView/styles';
import { CustomInputProps } from '../../components/inputs/components/dropdown/Dropdown';
import ProjectTitleEditable from './ProjectTitleEditable';
import { useTranslation } from 'react-i18next';
import { LayoutConst } from "../../../core";
import { FInter } from '@brg/ui';

const ProjectTitleSectionOuter = styled.div<{ isBookEdit?: boolean, isProjectEdit?: boolean, isCompetitionEdit?: boolean }>`
  position: relative;
  display: flex;
  margin-bottom: 24px;

  &:focus-within {
    .holder {
      display: none;
    }
  }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    ${({ isBookEdit }) => isBookEdit ? css`
    margin-top: 0px;
    margin-bottom: 32px;
    ` : css`
    margin-top: 0px;
    margin-bottom: 32px;
    `}
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    ${({ isProjectEdit, isCompetitionEdit }) => (isProjectEdit || isCompetitionEdit) ? css`
      margin-top: 0px;
      margin-bottom: 24px;
    ` : null}
  }

  
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    margin-bottom: 16px;
  }
`;

const Placeholder = styled(FInter.JustInCaseFlex)`
  color: ${({theme}) => theme.projectView.placeholderColor};
  position: absolute;
  pointer-events: none;
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 23px;
    line-height: 29px;
  }
`

type PropsT = {
  customProps?: CustomInputProps;
  projectTitle: string;
  setProjectTitle: (title: string) => void;
  isBookEdit?: boolean;
  isProjectEdit?: boolean;
  isCompetitionEdit?: boolean;
    isCollectionVote?: boolean;
    disabled?: boolean;
};

const TITLE_EDITABLE_ID = 'sct';

const ProjectTitleSection: FC<PropsT> = ({ customProps, projectTitle, setProjectTitle, disabled, isBookEdit, isProjectEdit, isCompetitionEdit, isCollectionVote }) => {
  const { t } = useTranslation();
  const isTitleEmpty = useMemo(() => projectTitle.trim() === '', [projectTitle]);

  const focusOnProjectTitleEditable = () => document.getElementById(TITLE_EDITABLE_ID)?.focus();

  return (
    <ProjectTitleSectionOuter isBookEdit={isBookEdit} isProjectEdit={isProjectEdit} isCompetitionEdit={isCompetitionEdit}>
      {isTitleEmpty && (
        <Placeholder
          onClick={focusOnProjectTitleEditable}
          className="holder"
        >
          {t('project_edit.title')}
          <LabelBigRedStar>*</LabelBigRedStar>
        </Placeholder>
      )}

      <ProjectTitleEditable
        id={TITLE_EDITABLE_ID}
        customProps={customProps}
        title={projectTitle}
        isCollectionVote={isCollectionVote}
        onTitleChange={setProjectTitle}
        isProjectEdit={isProjectEdit}
        disabled={disabled}
      />
    </ProjectTitleSectionOuter>
  );
};

export default ProjectTitleSection;
import { FC, useMemo } from 'react';
import styled, { css } from 'styled-components';
import { LabelBigRedStar } from '../designerEditView/styles';
import { CustomInputProps } from '../../components/inputs/components/dropdown/Dropdown';
import ProjectTitleEditable from './ProjectTitleEditable';
import { useTranslation } from 'react-i18next';
import { LayoutConst } from "../../../core";
import { FInter } from '@brg/ui';

const ProjectTitleSectionOuter = styled.div<{ isBookEdit?: boolean, isProjectEdit?: boolean, isCompetitionEdit?: boolean }>`
  position: relative;
  display: flex;
  margin-bottom: 24px;

  &:focus-within {
    .holder {
      display: none;
    }
  }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    ${({ isBookEdit }) => isBookEdit ? css`
    margin-top: 0px;
    margin-bottom: 32px;
    ` : css`
    margin-top: 0px;
    margin-bottom: 32px;
    `}
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    ${({ isProjectEdit, isCompetitionEdit }) => (isProjectEdit || isCompetitionEdit) ? css`
      margin-top: 0px;
      margin-bottom: 24px;
    ` : null}
  }

  
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    margin-bottom: 16px;
  }
`;

const Placeholder = styled(FInter.JustInCaseFlex)`
  color: ${({theme}) => theme.projectView.placeholderColor};
  position: absolute;
  pointer-events: none;
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 23px;
    line-height: 29px;
  }
`

type PropsT = {
  customProps?: CustomInputProps;
  projectTitle: string;
  setProjectTitle: (title: string) => void;
  isBookEdit?: boolean;
  isProjectEdit?: boolean;
  isCompetitionEdit?: boolean;
    isCollectionVote?: boolean;
    disabled?: boolean;
};

const TITLE_EDITABLE_ID = 'sct';

const ProjectTitleSection: FC<PropsT> = ({ customProps, projectTitle, setProjectTitle, disabled, isBookEdit, isProjectEdit, isCompetitionEdit, isCollectionVote }) => {
  const { t } = useTranslation();
  const isTitleEmpty = useMemo(() => projectTitle.trim() === '', [projectTitle]);

  const focusOnProjectTitleEditable = () => document.getElementById(TITLE_EDITABLE_ID)?.focus();

  return (
    <ProjectTitleSectionOuter isBookEdit={isBookEdit} isProjectEdit={isProjectEdit} isCompetitionEdit={isCompetitionEdit}>
      {isTitleEmpty && (
        <Placeholder
          onClick={focusOnProjectTitleEditable}
          className="holder"
        >
          {t('project_edit.title')}
          <LabelBigRedStar>*</LabelBigRedStar>
        </Placeholder>
      )}

      <ProjectTitleEditable
        id={TITLE_EDITABLE_ID}
        customProps={customProps}
        title={projectTitle}
        isCollectionVote={isCollectionVote}
        onTitleChange={setProjectTitle}
        isProjectEdit={isProjectEdit}
        disabled={disabled}
      />
    </ProjectTitleSectionOuter>
  );
};

export default ProjectTitleSection;
